import { render, staticRenderFns } from "./ssq.vue?vue&type=template&id=b494b428&scoped=true"
import script from "./ssq.vue?vue&type=script&lang=js"
export * from "./ssq.vue?vue&type=script&lang=js"
import style0 from "./ssq.vue?vue&type=style&index=0&id=b494b428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b494b428",
  null
  
)

export default component.exports